import { inverterInfo, weatherSensor } from 'models';
import axiosClient from './axiosClient';

const urlApi = '/api/v1/weather-station';
export const weatherApi = {
  fetchWeatherStation(id: string): Promise<inverterInfo>{
    const url = `${urlApi}?plant_id=${id}`;
    return axiosClient.get(url);  
  },
  add(weatherInfo: weatherSensor): Promise<inverterInfo>{
    return axiosClient.post(urlApi,weatherInfo)
  },
  remove(id: string): Promise<any> {
    const url = `${urlApi}?ws_station_id=${id}`;
    return axiosClient.delete(url);
  },
};